import { CircularLoading, EmptyList, Select } from '@foxtaibox/foxtailbox-frontend-core';
import {
  AssessmentWebTrialListOrderFields,
  OrderType,
  Trial_Status,
  useTrialsQuery,
} from '@generated/graphql';
import { Box, Grid2, SelectChangeEvent, Typography } from '@mui/material';
import { ASSESSMENT_STATUS_TITLE } from 'constants/assessment';
import AssessmentCard from 'pages/AssessmentList/components/AssessmentCard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMe from 'store/user/useMe';

type StatusFilterValue = Trial_Status & 'ALL';

const AssessmentList = () => {
  const { t } = useTranslation();
  const [statusFilter, setStatusFilter] = useState<StatusFilterValue>('ALL' as StatusFilterValue);
  // временный костыль для своевременной подгрузки данных при авторизации с наличием redirectUrl
  useMe();

  const STATUS_FILTER_ITEMS = Object.entries({
    ALL: t('assessmentList.all'),
    ...ASSESSMENT_STATUS_TITLE,
  }).map(([key, title]) => ({
    label: t(title),
    value: key,
  })) as { value: StatusFilterValue; label: string }[];

  const { data, loading, refetch } = useTrialsQuery({
    variables: {
      filter: {},
      limit: 100,
      page: 0,
      order: {
        field: AssessmentWebTrialListOrderFields.CreatedAt,
        order: OrderType.Desc,
      },
    },
    fetchPolicy: 'network-only',
  });

  const assessmentList = data?.trials.data;

  const onStatusFilterChanged = (event: SelectChangeEvent<string>) => {
    const value = event.target.value as StatusFilterValue;
    setStatusFilter(value);
    refetch({
      filter:
        value === 'ALL'
          ? {}
          : {
              status: value,
            },
    });
  };

  if (loading) return <CircularLoading />;

  return (
    <Box>
      <Typography variant='h28' mb={2.5}>
        {t('assessmentList.myAssessments')}
      </Typography>
      <Box mb={{ xs: 3, sm: 2.5 }}>
        <Select
          value={statusFilter}
          onChange={onStatusFilterChanged}
          items={STATUS_FILTER_ITEMS}
          sx={{
            minWidth: 176,
            backgroundColor: '#fff',
          }}
        />
      </Box>
      {assessmentList && assessmentList.length > 0 ? (
        <Grid2 container spacing={2.5}>
          {assessmentList?.map((assessment) => (
            <Grid2 size={{ xs: 12, md: 6, lg: 4 }} key={`user-assessment-card-${assessment.id}`}>
              <AssessmentCard assessment={assessment} />
            </Grid2>
          ))}
        </Grid2>
      ) : (
        <EmptyList emptyPlaceholderText={t('assessmentList.emptyList')} />
      )}
    </Box>
  );
};

export default AssessmentList;
